module.exports = {"tags":"Category","category":"Loyalty Category","outlet":"Station"};